import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
//components
import Toggle from "../../../../../components/button/Toggle";
import NumberInput from "../../../../../components/input/NumberInput";
//primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
//services
import {getFinancing} from "../../../../../services/Settings/Simulator/getFinancing";
import {postFinancing} from "../../../../../services/Settings/Simulator/postFinancing";
//utils
import { queryClient } from "../../../../../utils/queryClient";
import { useAppContext } from "../../../../../context/AppContext";

const Corrections = ({setActiveIndex}) => {
  const { id } = useParams();
  const { permissions } = useAppContext();
  const form = useForm();
  const errors = form.formState.errors;

  const [loadingButton, setLoadingButton] = useState(false);

  const { data: dataFinancing, isLoading } = useQuery(
    `dataFinancing${id}`, 
    () => getFinancing(id),
    { enabled: !!permissions?.includes("88") }
  );

  const { mutateAsync: postFinancingFn } = useMutation({
    mutationFn: postFinancing,
    onSuccess(_, variables) {
      queryClient.setQueryData([`dataFinancing${id}`], (data) => {
        delete variables.enterprise_id;
        return variables;
      });
    },
    onError(error) {
//      console.log(error);
    },
  });
//  // console.log(dataFinancing)

  const onSubmit = async (data) => {
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");

    data.enterprise_id = parseInt(id);
    data.outstanding_balance_rate = data.outstanding_balance_rate ? data.outstanding_balance_rate : 0;
    const variables = {
      ...data,
    };

    try {
      await postFinancingFn(variables);
      setLoadingButton(false);
      toast.update(notification, {
        render: "Configurações do Financiamento editado com sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      form.reset();
      setActiveIndex(1);
      // refetch();
      return;
    } catch (err) {
//      console.log(err);
      toast.update(notification, {
        render: "Houve um erro!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      form.reset();
      return err;
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };


  useEffect(() => {
    if (dataFinancing) {
//      console.log(dataFinancing);
      const defaultValues = {
        outstanding_balance_rate:
          dataFinancing.outstanding_balance_rate === 0
            ? "0"
            : dataFinancing.outstanding_balance_rate,
        financing_max_installments: dataFinancing.financing_max_installments,
        outstanding_balance_fixed: dataFinancing.outstanding_balance_fixed,
      };
      form.reset(defaultValues);
    }
  }, [dataFinancing, form]);

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
      <div className="row">
        <div className="col-md-4 my-3">
          <h3>
            {" "}
            Saldo Devedor
            <Tooltip target=".custom-target-icon" />
            <i
              className="custom-target-icon px-2 pi 
      pi-info-circle p-text-secondary"
              data-pr-tooltip="Caso defina um taxa, ela será aplicada no saldo devedor de acordo com a quantidade de parcelas de entrada"
              style={{ cursor: "pointer" }}
            ></i>
          </h3>

          <NumberInput
            name="outstanding_balance_rate"
            suffix="%"
            placeholder="0%"
            max={100}
            minFractionDigits={2}
            control={form.control}
            disabled={isLoading}
            label={isLoading ? "Carregando..." : "Taxa de Correção do Saldo Devedor"}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
        <div className="col-md-4 my-3">
          <h3>
            {" "}
            Parcelas do Financiamento
            <Tooltip target=".custom-target-icon" />
            <i
              className="custom-target-icon px-2 pi pi-info-circle p-text-secondary"
              data-pr-tooltip="Você pode cobrar uma taxa de juros para parcelar as intermediárias"
              style={{ cursor: "pointer" }}
            ></i>
          </h3>
          <NumberInput
            name="financing_max_installments"
            placeholder="0"
            max={1000}
            control={form.control}
            disabled={isLoading}
            required={true}
            label={isLoading ? "Carregando..." : "Máximo de Parcelas do Financiamento"}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
        <div className="col-md-4 my-2 pt-5">
          <Toggle
            name="outstanding_balance_fixed"
            onLabel="Correção Saldo Devedor Fixo"
            offLabel="Correção Saldo Devedor Fixo"
            tooltip="Caso este campo esteja habilitado, será cobrado a taxa no saldo devedor,independente da quantidade de parcelas de entrada"
            tooltipOptions={{ position: "top" }}
            className="mt-2"
            control={form.control}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <div className="col-md-2 text-end">
          <Button
            rounded
            type="submit"
            iconPos="right"
            label="Salvar"
            disabled={isLoading}
            loading={loadingButton}
            icon="fa-solid fa-check"
            className="p-inputtext-sm m-auto"
          />
        </div>
      </div>
    </form>
  );
};

export default Corrections;
